import React, { useEffect, useState } from 'react';
import AdminHeading from '../AdminPanel/Heading/AdminHeading';
import AdminBreadCrump from '../AdminPanel/Heading/AdminBreadCrump';
import '../PagesStyles/AdminMasters.css';
import { TbCircleNumber1 } from 'react-icons/tb';
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a18,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
  a720,
  a721,
  a722,
} from '../../Api/RootApiPath';
import { useSelector } from 'react-redux';
import { RiListUnordered, RiPlayListAddLine } from 'react-icons/ri';
import AlertMessage from '../../Other Functions/AlertMessage';
import { financialYearsList } from '../../Api/FinancialYearsList';
import { allCountriesList } from '../../Api/CountriesAllList';
import { allStateList } from '../../Api/StateList';
import { Icon } from '@iconify/react';
import Customertable from 'Components/support/customervendor/customer';
import style from './AddNewCustomer.module.css';
import { useRef } from 'react';
import toast from 'react-hot-toast';

export default function AddTaxNew() {
  const [active, setActive] = useState('AddNew');
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState('');
  const [messageToShow, setMessageToShow] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  const [countryStates, setCountryStates] = useState([]);

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    Country: '',
    State: '',
    TaxName: '',
    Rate: '',
    TaxType: '',
    Description: '',
    FinancialYearFormat: '',

    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  // const [allCountriesList, setAllCountriesList] = useState([]);
  const [allStatesList, setAllStatesList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  useEffect(() => {
    console.log('countryStates', countryStates);
  }, [countryStates]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a722, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive('addNew');
        document
          .getElementById('addCategoryListTitle')
          .classList.add('activeCategoryTitle');
        document
          .getElementById('addCategoryListLogo')
          .classList.add('activeCategoryLogo');
        document.getElementById('addCategoryListTitle').click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log('Searching for:', searchTerm);
  };

  const handleList = () => {
    // Custom logic for the List button
    console.log('List button clicked');
    setActive('List');
  };

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  useEffect(() => {
    console.log('countryStates', countryStates);
  }, [countryStates]);
  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);
  console.log(allCategories, 'allCategories');
  console.log(allCompaniesList, 'allCompaniesList');
  console.log(allDepartmentsList, 'allDepartmentsList');
  console.log(allBranchesList, 'allBranchesList');
  console.log(allRolesList, 'allRolesList');
  const states = {
    US: ['California', 'Texas', 'Florida', 'New York'],
    IN: allStateList,
    // Add more states for each country as needed
  };

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });

    if (name === 'Country') {
      let updatedStates = [];
      if (value === 'India') {
        updatedStates = states.IN; // Set states for India
      } else if (value === 'United States') {
        updatedStates = states.US; // Set states for the US
      }
      setCountryStates(updatedStates); // Update the country states
      setNewCategory((prev) => ({
        ...prev,
        Country: value,
        State: '', // Reset state when country changes
      }));
    } else if (name === 'State') {
      setNewCategory((prev) => ({
        ...prev,
        State: value, // Update the selected state
      }));
    } else {
      setNewCategory((prev) => ({
        ...prev,
        [name]: value, // Update other fields dynamically
      }));
    }
  };
  console.log(newCategory, 'newCategory');
  console.log(newCategory, 'newCategory');

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      Country: newCategory.Country,
      State: newCategory.State,
      Rate: newCategory.Rate,
      TaxType: newCategory.TaxType,
      TaxName: newCategory.TaxName,
      Description: newCategory.Description,
      FinancialYearFormat: newCategory.FinancialYearFormat,

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, 'formData to send');
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a720 : a721,
        // a96,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive('List');
      setNewCategory({
        Country: '',
        State: '',
        TaxName: '',
        Rate: '',
        TaxType: '',
        Description: '',
        FinancialYearFormat: '',
        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.Message);
        // setMessageType("error");
        toast.error(data.Message, {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
        setActive('AddNew');
      } else {
        // setMessageType("success");
        toast.success('Category Added Successfully', {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, 'data');
    console.log(data, 'data');
    console.log(data, 'data');
    setNewCategory({ ...data, OldEntry: true });
    setActive('AddNew');
  };

  const columns = [
    { key: 'serialNumber', label: 'S.No', type: 'read', priority: 2 },
    { key: 'Country', label: 'Country', type: 'read', priority: 1 },

    { key: 'State', label: 'State', type: 'read', priority: 3 },
    { key: 'TaxName', label: 'TaxName', type: 'read', priority: 4 },
    { key: 'Rate', label: 'Percent', type: 'read', priority: 5 },
    { key: 'TaxType', label: 'TaxType', type: 'read', priority: 6 },

    {
      key: 'FinancialYearFormat',
      label: 'Financial Year',
      type: 'read',
      priority: 7,
    },
    { key: 'Description', label: 'Description', type: 'read', priority: 8 },
  ];

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);
  const inputRef12 = useRef(null);
  const inputRef13 = useRef(null);
  const inputRef14 = useRef(null);
  const inputRef15 = useRef(null);
  const inputRef16 = useRef(null);
  const inputRef17 = useRef(null);
  const inputRef18 = useRef(null);
  const inputRef19 = useRef(null);
  const inputRef20 = useRef(null);
  const inputRef21 = useRef(null);
  const inputRef22 = useRef(null);

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);
  // Handler function to move focus on Enter key press

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
      inputRef15,
      inputRef16,
      inputRef17,
      inputRef18,
      inputRef19,
      inputRef20,
      inputRef21,
      inputRef22,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === 'SELECT') {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ''; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error('Submit button ref is not available');
        }
      }
    }
  };
  const handlenew = () => {
    setActive('AddNew');
  };

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: '130px' }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={'Add Taxes'}
          companyName={'Loyalstring'}
          module={'User Masters'}
          page={'Taxes'}
        />
      </div>

      <div style={{ padding: '16px' }}>
        {active == 'List' ? (
          <>
            <div className={style['white-space']}>
              <div className={style['icon-div']}>
                <div className={style['search-container']}>
                  <input
                    type="text"
                    value={searchInput}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                    className={style['serach-input']}
                  />
                  <button
                    style={{ margin: 0 }}
                    className={style['search-btn']}
                    onClick={handleSearchSubmit}
                  >
                    <Icon style={{ fontSize: '20px' }} icon="mdi:magnify" />
                  </button>
                </div>

                <Icon
                  style={{
                    fontSize: '28px ',
                    color: '#0077d4',
                    cursor: 'pointer',
                  }}
                  icon="bx:export"
                />

                <button
                  // style={{ width: "30%" }}
                  className={style['custom-btn']}
                >
                  <Icon style={{ fontSize: '24px ' }} icon="ic:outline-print" />
                  Print
                </button>
                <button
                  onClick={handlenew}
                  style={{ margin: 0 }}
                  className={style['custom-btn']}
                >
                  New
                  <Icon icon="mdi:plus" width="24" height="24" />
                </button>
              </div>
            </div>

            <Customertable
              columns={columns}
              allCategories={allCategories}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
          </>
        ) : (
          <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
                <p>Add New Tax</p>
                <form onSubmit={addNewCategory}>
                  <div
                    style={{
                      gridTemplateColumns: 'repeat(4,1fr)',
                      columnGap: '40px',
                    }}
                    className="adminCategoryAddCategoryInnerBox"
                  >
                    <label>
                      Country <sup>*</sup>
                    </label>
                    <select
                      name="Country"
                      required
                      value={newCategory.Country}
                      onChange={handleNewCategoryChange}
                      ref={inputRef1}
                      onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                    >
                      <option value={''}>Select Country</option>
                      {allCountriesList.map((x) => (
                        <option value={x}>{x}</option>
                      ))}
                    </select>
                    <label>
                      State <sup>*</sup>
                    </label>
                    <select
                      name="State"
                      value={newCategory.State}
                      onChange={handleNewCategoryChange}
                      required
                      style={{ border: '1px solid #ccc' }}
                      className={style.AddCustomerInput}
                      ref={inputRef8}
                      onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                    >
                      <option value="" disabled>
                        Select a state
                      </option>
                      {countryStates.map((x, index) => (
                        <option key={index} value={x}>
                          {x}
                        </option>
                      ))}
                    </select>
                    {/* <input
                      name="State"
                      required
                      value={newCategory.State}
                      onChange={handleNewCategoryChange}
                      list="supplierNamesList"
                      style={{border: '1px solid #ddd'}}
                      ref={inputRef2}
                          onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                    />
                    <datalist id="supplierNamesList">
                      {allStateList.map((item, index) => (
                        <option key={index} value={item} />
                      ))}
                    </datalist> */}
                    <label>
                      Tax Name <sup>*</sup>
                    </label>
                    <input
                      name="TaxName"
                      value={newCategory.TaxName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: '1px solid #ddd' }}
                      ref={inputRef3}
                      onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                    />
                    <label>
                      Tax Type <sup>*</sup>
                    </label>

                    <select
                      name="TaxType"
                      value={newCategory.TaxType}
                      onChange={handleNewCategoryChange}
                      required
                      ref={inputRef4}
                      onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                    >
                      <option value={''}>Select Tax Type</option>
                      <option value={'GST'}>GST</option>
                      <option value={'SALES TAX'}>SALES TAX</option>
                      <option value={'VAT'}>VAT</option>
                      <option value={'EXCISE'}>EXCISE</option>
                      <option value={'INCOME TAX'}>INCOME TAX</option>
                      <option value={'TCS'}>TCS</option>
                      <option value={'TDS'}>TDS</option>
                      <option value={'GST ON REPAIR'}>GST ON REPAIR</option>
                      <option value={'GST ON ORDER'}>GST ON ORDER</option>
                    </select>
                    <label>
                      Percentage % <sup>*</sup>
                    </label>
                    <input
                      name="Rate"
                      value={newCategory.Rate}
                      onChange={handleNewCategoryChange}
                      type="number"
                      placeholder="Between 0 to 100"
                      style={{ border: '1px solid #ddd' }}
                      ref={inputRef5}
                      onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                    />
                    <label>
                      Financial Year <sup>*</sup>
                    </label>

                    <select
                      name="FinancialYearFormat"
                      value={newCategory.FinancialYearFormat}
                      onChange={handleNewCategoryChange}
                      required="required"
                      ref={inputRef6}
                      onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                    >
                      <option value={''}>Choose Financial Year</option>

                      {financialYearsList.map((x, index) => (
                        <option key={index} value={x}>
                          {x}
                        </option>
                      ))}
                    </select>

                    <label>Description</label>
                    <input
                      name="Description"
                      value={newCategory.Description}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: '1px solid #ddd' }}
                      ref={inputRef7}
                      onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                    />
                  </div>
                  {!loading ? (
                    <div className={style['btn-container']}>
                      <button className={style.buttons} type="submit">
                        <Icon icon="ic:baseline-check" width="24" height="24" />{' '}
                        Submit
                      </button>
                      <button
                        className={style.buttons}
                        style={{
                          backgroundColor: '#fff',
                          color: '#0077d4',
                          border: '1px solid #0077d4',
                        }}
                        type="button"
                        onClick={handleResetField}
                      >
                        <Icon
                          style={{ color: '#0077d4' }}
                          icon="ix:reset"
                          width="24"
                          height="24"
                        />
                        Reset
                      </button>
                      <button
                        className={style.buttons}
                        type="button"
                        onClick={handleList}
                      >
                        <Icon
                          icon="fluent:list-rtl-16-filled"
                          width="24"
                          height="24"
                        />
                        List
                      </button>
                    </div>
                  ) : null}
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
